<ihd-avatar *ngIf="showAvatar" class="ihd-media-object c-media__object x-media-object__avatar"
            [ngClass]="mediaClass"
            [ngStyle]="mediaStyle"
            [user]="media"
            [imgField]="imgField"></ihd-avatar>
<ihd-icon *ngIf="!showAvatar" class="ihd-media-object c-media__object" [ngClass]="mediaClass" [ngStyle]="mediaStyle" [name]="media"></ihd-icon>
<div class="ihd-media-body">
    <div class="ihd-media-title c-media__title" *ngIf="heading">{{heading}}</div>
    <ng-content select="[media-body]"></ng-content>
</div>
